import React, { forwardRef, useState, useImperativeHandle } from "react";
import SnNumberBox from "@shared/components/SnNumberBox";
import SnNumPadButton from "@shared/components/SnNumPadButton";

interface NumPadPopupProps {
  defaultValue: number;
  decimalPoint: number;
}

const NumPadPopup = forwardRef(
  (
    { defaultValue, decimalPoint }: NumPadPopupProps,
    popupRef: React.Ref<any>
  ) => {
    const [value, setValue] = useState(String(defaultValue ?? "0"));

    const makeFormat = (decimalPoint: number) => {
      return decimalPoint > 0 ? `0.${"0".repeat(decimalPoint)}` : "0";
    };

    useImperativeHandle(popupRef, () => ({
      getOkayData: () => {
        const numData: any[] = [];
        numData.push(Number(value));

        return {
          rtnData: numData,
        };
      },
    }));

    const onClick = (key: string) => {
      let calcQt = value;

      switch (key) {
        case "C":
          calcQt = "0";
          break;
        case "B":
          calcQt = calcQt.slice(0, -1) || "0";

          if (calcQt.endsWith(".")) {
            calcQt = calcQt.slice(0, -1) || "0";
          }
          break;
        case "D":
          if (!calcQt.includes(".")) {
            calcQt = calcQt === "0" ? "0." : calcQt + ".";
          }
          break;
        default:
          calcQt = calcQt === "0" ? key : calcQt + key;
          break;
      }

      if (calcQt.includes(".")) {
        const [i, d = ""] = calcQt.split(".");
        calcQt = `${i}.${d.slice(0, decimalPoint)}`;
      }

      setValue(calcQt);
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            width: "300px",
          }}
        >
          <SnNumberBox
            format={makeFormat(decimalPoint)}
            defaultValue={Number(value)}
            readOnly={true}
            inputHeight={60}
            fontSize={26}
            borderWidth="2px"
          />
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 90px)",
            gridAutoRows: "50px",
            gap: "10px",
          }}
        >
          <SnNumPadButton
            text={"1"}
            onClick={() => {
              onClick("1");
            }}
          />
          <SnNumPadButton
            text={"2"}
            onClick={() => {
              onClick("2");
            }}
          />
          <SnNumPadButton
            text={"3"}
            onClick={() => {
              onClick("3");
            }}
          />

          <SnNumPadButton
            text={"4"}
            onClick={() => {
              onClick("4");
            }}
          />
          <SnNumPadButton
            text={"5"}
            onClick={() => {
              onClick("5");
            }}
          />
          <SnNumPadButton
            text={"6"}
            onClick={() => {
              onClick("6");
            }}
          />

          <SnNumPadButton
            text={"7"}
            onClick={() => {
              onClick("7");
            }}
          />
          <SnNumPadButton
            text={"8"}
            onClick={() => {
              onClick("8");
            }}
          />
          <SnNumPadButton
            text={"9"}
            onClick={() => {
              onClick("9");
            }}
          />

          <SnNumPadButton
            text={"."}
            onClick={() => {
              onClick("D");
            }}
          />
          <SnNumPadButton
            text={"0"}
            onClick={() => {
              onClick("0");
            }}
          />
          <SnNumPadButton
            text={"←"}
            onClick={() => {
              onClick("B");
            }}
          />

          <SnNumPadButton
            text={"C"}
            onClick={() => {
              onClick("C");
            }}
          />
        </div>
      </div>
    );
  }
);

export default NumPadPopup;
